/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Basket.Samples.Entrance.Headline';
export const Paragraph = 'Website.Basket.Samples.Entrance.Paragraph';
export const Button = 'Website.Basket.Samples.Entrance.Button';
